export enum actionTypes {
  PREGUNTAS_PREDEFINIDAS_FETCH = 'PREGUNTAS_PREDEFINIDAS_FETCH',
  PREGUNTAS_PREDEFINIDAS_SUCCESS = 'PREGUNTAS_PREDEFINIDAS_SUCCESS',
  PREGUNTAS_PREDEFINIDAS_ERROR = 'PREGUNTAS_PREDEFINIDAS_ERROR',
  PREGUNTAS_PREDEFINIDAS_RESET = 'PREGUNTAS_PREDEFINIDAS_RESET',
}

export enum PreguntasPredefinidasStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface PreguntaPredefinida {
  id: number
  nombre: string
}

export interface PreguntasPredefinidasState {
  status: PreguntasPredefinidasStatus
  preguntasPredefinidas: Array<PreguntaPredefinida>
}

export interface PreguntasPredefinidasFetch {
  type: typeof actionTypes.PREGUNTAS_PREDEFINIDAS_FETCH
  payload: null
}

export interface PreguntasPredefinidasSuccess {
  type: typeof actionTypes.PREGUNTAS_PREDEFINIDAS_SUCCESS
  payload: { preguntasPredefinidas }
}

export interface PreguntasPredefinidasError {
  type: typeof actionTypes.PREGUNTAS_PREDEFINIDAS_ERROR
  payload: null
}

export interface PreguntasPredefinidasReset {
  type: typeof actionTypes.PREGUNTAS_PREDEFINIDAS_RESET
  payload: null
}

export type PreguntasPredefinidasActions =
  | PreguntasPredefinidasFetch
  | PreguntasPredefinidasSuccess
  | PreguntasPredefinidasError
  | PreguntasPredefinidasReset

export const initialState: PreguntasPredefinidasState = {
  status: PreguntasPredefinidasStatus.Idle,
  preguntasPredefinidas: [],
}
